export class FbTabPanelButtonConfiguration{

    constructor(public titles : Array<string>, public action : Function, public activeIndex : number){}

    public static create = (titles : Array<string>, action : Function, activeIndex : number) => new FbTabPanelButtonConfiguration(titles, action, activeIndex);

}
